import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'

const filters = {
  // uk format
  date: value => {
    if (value == null || value === '0000-00-00 00:00:00') return ''
    return format(parseISO(value), 'dd MMMM yyyy')
  },
  datetime: value => {
    if (value == null || value === '0000-00-00 00:00:00') return ''
    return format(parseISO(value), 'dd MMMM yyyy HH:mm') // no seconds
  },
  datetimesec: value => {
    if (value == null || value === '0000-00-00 00:00:00') return ''
    return format(parseISO(value), 'dd MMMM yyyy HH:mm:ss') // with seconds
  },
  day_month: value => {
    if (value == null || value === '0000-00-00 00:00:00') return ''
    return format(parseISO(value), 'dd MMMM')
  },
  underscore_to_space: value => {
    return value.replace(/_/g, ' ')
  }
}

export default filters
